import Highcharts from 'highcharts';

import { getSMSizes } from './data.js';
import { loadPolandMapData } from './maps.js';

/**
 * @param {string} id
 */
export default async function mapBudget(id) {
    if (!document.getElementById(id)) return;

    const mapData = await loadPolandMapData();
    const smData = getSMSizes()
    smData.forEach(city => {
        city.b = city['Budżet'];
        city.l = city['Liczba mieszkańców'];
        city.e = city['Etaty: liczba strażników'];
    })

    const avgBudgetPerCitizen = smData.reduce((sum, city) => sum + city.b / city.l, 0) / smData.length;

    const budget = [...smData]
    budget.forEach(city => {
        city.z = city.b / city.l;
        city.value = city.z;
        // Dodaj współrzędne geograficzne dla każdego miasta
        city.x = city.lon;
        city.y = city.lat;
    })

    const series = [];

    if (mapData) {
        series.push({
            type: 'map',
            name: 'Polska',
            mapData,
            color: '#f0f0f0',
            borderColor: '#606060',
            borderWidth: 0.5,
            nullColor: '#f0f0f0',
            showInLegend: false,
            enableMouseTracking: false
        });
    }

    // Dodaj serię z bąbelkami miast
    series.push({
        type: 'mapbubble',
        name: 'Budżet na mieszkańca',
        data: budget,
        maxSize: '25%',
        minSize: '5%',
        colorAxis: 'budget-axis',
        colorKey: 'value',

        dataLabels: {
            enabled: true,
            format: '{point.city}<br>{point.z:,.0f} zł',
            style: {
                fontSize: '11px',
                color: '#2c3e50',
                textOutline: '2px white'
            }
        }
    });

    // @ts-ignore - ignoruj błędy TypeScript dla konfiguracji mapy
    Highcharts.mapChart(id, {
        chart: {
            backgroundColor: 'transparent'
        },
        title: { text: 'Roczny budżet SM na mieszkańca' },
        subtitle: { text: `Średnia: ${avgBudgetPerCitizen.toFixed(0)} zł` },

        mapNavigation: {
            enabled: false
        },
        colorAxis: {
            id: 'budget-axis',
            min: 20,
            max: 140,
            stops: [
                [0, '#e74c3c'],   // Czerwony (< 20 zł)
                [0.5, '#f1c40f'], // Żółty (środek skali)
                [1, '#2ecc71']    // Zielony (> 140 zł)
            ],
            labels: {
                format: '{value} zł'
            }
        },
        tooltip: {
            pointFormat: '<b>{point.z:,.0f} zł</b> na mieszkańca<br>Budżet całkowity: <b>{point.b:,.0f} zł</b>'
        },
        credits: { enabled: false },
        series: series
    });
}
